///
/// EarthBrowser
///
/// Created by Matt Giger on 9/24/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Drag-and-drop handler for georeferenced image ground overlays
/// (PNG/JPEG/WebP). Opens a floating properties window where the user
/// places the image on the globe (lat/lon bounds + opacity); the original
/// file is parked for "Save to cloud" so the overlay can be shared and
/// referenced by story tours.
///

import { registerDatasetSourceFile } from "@/components/features/user-datasets/datasetSourceFiles"
import { mountImageOverlay } from "@/utils/imageOverlayMount"
import { BaseFileHandler } from "./BaseFileHandler"

export class ImageFileHandler extends BaseFileHandler {
	canHandle(file: File): boolean {
		return /\.(png|jpe?g|webp)$/i.test(file.name)
	}

	initialize(): void {}

	cleanup(): void {}

	async handleFile(file: File): Promise<string | null> {
		const windowId = await mountImageOverlay(this.context.dispatch, this.context.getState, file)
		if (windowId) {
			// Park the original bytes so SaveToCloudButton can upload them
			registerDatasetSourceFile(windowId, { file, format: "image" })
		}
		return windowId
	}
}
